// src/hooks/useWindowSize.js
import { useState, useCallback, useRef } from 'react';

export default function WindowSize() {
  const [size, setSize] = useState({ width: 0, height: 0 });
  const observerRef = useRef(null);

  // ref callback que o React chama quando o elemento monta/desmonta
  const ref = useCallback(node => {
    // desconecta observer anterior (se houver)
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }

    if (node) {
      // já pega o tamanho inicial
      const { width, height } = node.getBoundingClientRect();
      setSize({ width, height });

      // cria um ResizeObserver para acompanhar mudanças
      observerRef.current = new ResizeObserver(([entry]) => {
        const { width, height } = entry.contentRect;
        setSize({ width, height });
      });
      observerRef.current.observe(node);
    }
  }, []);

  return [ref, size];
}
